import React from 'react';
import Chart from '../components/Chart';
import { useRealtimeRankingFluctuationDaily } from '../context/RealtimeRankingFluctuationContext';

const RealtimeRankingFluctuation: React.FC = () => {
  const { data, loading, error: wsError } = useRealtimeRankingFluctuationDaily();


  if (loading) {
    return (
      <div className="loading-container">
        <p>WebSocket 연결 중...</p>
      </div>
    );
  }

  if (wsError) {
    return (
      <div className="error-container">
        <p>❌ {wsError}</p>
      </div>
    );
  }

  // console.log('🎯 Chart에 전달되는 데이터:', data.length, '개 항목');
  // console.log('🎯 Chart 데이터 샘플:', data[0]);

  return (
    <div className="realtime-ranking-fluctuation">
      <Chart
        data={data}
        loading={loading}
        error={null}
        onRefetch={() => {}}
        colors={['#ef4444', '#22c55e', '#3b82f6', '#8b82f6', '#f59e0b']}
      />
    </div>
  );
};

export default RealtimeRankingFluctuation;